import Player from '../player'
import sniffer from '../utils/sniffer'
import '../style/player/poster.scss'

let poster = function () {
  let player = this; let util = Player.util
  let poster = util.createDom('xg-poster', '', {}, 'xgplayer-poster')
  let root = player.root
  if (player.config.poster) {
    poster.style.backgroundImage = `url(${player.config.poster})`
    root.appendChild(poster)
  }

  function hiddenPoster () {
    poster.style.display = 'none'
  }
  util.on(player, 'play', hiddenPoster, 'destroy')
  // if (sniffer.device === 'pc') {
  util.on(player, 'complete', hiddenPoster, 'destroy')
  // }
}

export default {
  name: 'poster',
  method: poster
}